function get_stystem() {
    var userAgent = navigator.userAgent.toLowerCase();
    return {
        iphone: /(iphone|ipod|ipad)/i.test(userAgent),
        android: /android/.test(userAgent),
        kkmh: /kuaikan\//.test(userAgent),
    };
}

function kkmhhybrid_set_3dtouch(opt) {
    hybrid({
        hybridParam: {
            schema: "kkmhhybrid",
            tagname: "set_3dtouch",
        },
        param: {
            status: opt.status, // 1-开启3dtouch，0-关闭3dtouch(默认关闭)
        },
        callback: function (res) {
            opt.callback && opt.callback(res);
        }
    });
}

/**
 * 控制3dtouch-set_3dtouch<br>
 * 本3dtouch协议的功能是通过3dtouch来预览一个链接页面
 * kkmhhybrid://set_3dtouch{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=140902460}<br>
 * @param {Object} opt 参数对象
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */

function set_3dtouch(opt, criticalAppVersion) {
    if (criticalAppVersion === undefined) {
        criticalAppVersion = window.kkBaseInfo.criticalAppVersion;
    }
    if (window.kkBaseInfo.appVersion < criticalAppVersion) {
        // 调用老协议
        let res = {
            type:'err',
            data: {},
            message: `当前app版本不支持本协议，请将app升级至${criticalAppVersion}版本及以上`,
        }
        opt.callback && opt.callback(res);

    } else {
        // 调用新协议
        if (get_stystem()["iphone"]) {
            kkmhhybrid_set_3dtouch(opt);
        } else {
            // 本协议只在ios中生效
            let res = {
                type:'err',
                data: {},
                message: `当前设备系统为android，本协议只在ios中生效`,
            }
            opt.callback && opt.callback(res);
        }
    }
}

export default set_3dtouch;



// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/set_3dtouch/index.js